<template>
  <div class="lock-bidding-wrapper">
    <div class="title">
      {{ titleFirst }}
      <br />
      {{ trans("live.tabs.lock_unlock.title_2") }}
    </div>
    <locked-bidding-btn></locked-bidding-btn>

    <a class="btn btn-blue-outline btn-return" @click="openFirstTab">
      {{ trans("live.tabs.lock_unlock.return_btn_label") }}
    </a>
  </div>
</template>
<script setup lang="ts">
  import LockedBiddingBtn from "@/components/_partials/LockedBiddingBtn.vue";
  import { trans } from "@/utils/trans";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { computed } from "vue";

  const auctionStore = useAuctionStore();

  const emit = defineEmits(["changeTab"]);

  const openFirstTab = () => {
    const tab = auctionStore.user?.is_admin ? "users" : "history";
    emit("changeTab", tab);
  };

  const titleFirst = computed(() => {
    if (!auctionStore.user?.is_admin) {
      return trans("live.tabs.lock_unlock.buyer_title_1");
    } else {
      return trans("live.tabs.lock_unlock.title_1");
    }
  });
</script>
